import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonEn from './localization/en/common.json';
import commonNl from './localization/nl/common.json';

const resources = {
  en: { common: commonEn },
  nl: { common: commonNl },
};

const detection = {
  order: ['querystring', 'localStorage', 'navigator'],
  lookupQuerystring: 'lng',
};

const setDocumentLanguage = (language: string) => {
  document.documentElement.lang = language;
};

i18n.on('languageChanged', setDocumentLanguage);

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection,
    supportedLngs: ['nl', 'en'],
    fallbackLng: 'nl',
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
    resources,
  });

setDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);

export default i18n;
